document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('#shopify-section-template--27726429716862__section_APrArK');
  if (!section) return;
  
  const revealElements = section.querySelectorAll('img, .image-with-text__text-item:not(.image-with-text__heading), p, .rte');
  revealElements.forEach(el => el.classList.add('reveal-element'));
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('revealed')) {
        const index = Array.from(revealElements).indexOf(entry.target);
        setTimeout(() => {
          entry.target.classList.add('revealed');
        }, index * 150);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '50px' });
  
  revealElements.forEach(el => observer.observe(el));
});
